export default __webpack_public_path__ + "static/media/sports-hover.56d6680f.webp";